export default __webpack_public_path__ + "static/media/user.ecc095cd.svg";